import { render, staticRenderFns } from "./jsonEditor.vue?vue&type=template&id=7b808db0&scoped=true"
import script from "./jsonEditor.vue?vue&type=script&lang=js"
export * from "./jsonEditor.vue?vue&type=script&lang=js"
import style0 from "./jsonEditor.vue?vue&type=style&index=0&id=7b808db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b808db0",
  null
  
)

export default component.exports